import { Menu } from '../menu/menu';

/**
 * @deprecated use Menu class instead: import { Menu } from 'main.popup'
 */
export class PopupMenuWindow extends Menu
{
	// No additional functionality, just for compatibility
}
